//@ts-nocheck
import { applySnapshot, getSnapshot, types } from "mobx-state-tree";

export const AgreementStore = types
  .model("AgreementStore", {
    lessonPercent: types.optional(types.boolean, false),
    contractAgreement: types.optional(types.boolean, false),
    paymentDate: types.optional(types.boolean, false),
    taxCompliance: types.optional(types.boolean, false),
    amountEarned: types.optional(types.number, 0),
    taxP: types.optional(types.number, 5),
  })
  .views((self) => {
    return {
      get formValues() {
        return getSnapshot(self);
      },
      get completed() {
        return Boolean(
          self.lessonPercent &&
            self.paymentDate &&
            self.taxCompliance &&
            self.contractAgreement,
        );
      },
    };
  })
  .actions((self) => {
    return {
      updateFields(values) {
        const oldValues = getSnapshot(self);
        applySnapshot(self, { ...oldValues, ...values });
      },
    };
  });
